module.exports = __webpack_public_path__ + "assets/2e2fb859b963206f4079271d3a5ccb26.mp3";